import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './ProgressBar.module.css';
import { classNames, formatNumberString } from '../../utils';
import { Tooltip, makeStyles } from '@material-ui/core';
const useStyles = makeStyles((theme) => ({
    customTooltip: (props) => ({
        backgroundColor: '#333',
        color: props.highlightValue ? 'var(--notification-red)' : 'var(--turquoise-base)',
        fontSize: 16,
        padding: theme.spacing(1),
        fontWeight: 400,
    }),
    customArrow: {
        color: '#333',
    },
}));
const ProgressBar = ({ className, perceivedProgress, totalProgress = 100, showDots, isEDMProgress, isSignalStrength = false, signalStyles, highlightValue, tooltip, }) => {
    const classes = useStyles({ highlightValue });
    const percentage = (perceivedProgress / totalProgress) * 100;
    const barGraph = () => (_jsxs("div", Object.assign({ className: classNames(styles.progressBar, className) }, { children: [_jsx("div", { className: classNames(isEDMProgress && perceivedProgress === 5 && styles.zeroPercentOnEdm, highlightValue ? styles.progressBarInRed : styles.progressBarInBlue, !isSignalStrength && styles.highlightBar, isSignalStrength && signalStyles), style: { width: `${percentage}%` } }, void 0), showDots && (_jsxs("div", Object.assign({ className: styles.dotLayer }, { children: [_jsx("div", { className: classNames(styles.barDot, styles.dot1) }, void 0), _jsx("div", { className: classNames(styles.barDot, styles.dot2) }, void 0), _jsx("div", { className: classNames(styles.barDot, styles.dot3) }, void 0), _jsx("div", { className: classNames(styles.barDot, styles.dot4) }, void 0)] }), void 0))] }), void 0));
    if (tooltip) {
        return (_jsx(Tooltip, { children: barGraph(), title: formatNumberString(percentage, {
                numDecimals: 1,
                unit: '%',
                spaceBetweenValueAndUnit: false
            }), arrow: true, placement: 'top', classes: {
                tooltip: classes.customTooltip,
                arrow: classes.customArrow,
            } }, void 0));
    }
    else {
        return barGraph();
    }
};
export default ProgressBar;
